export const validateStoreMessageData = (values, {translate}) => {
  const errors = {};

  if (!values.sms_from || values.sms_from.trim() === "") {
    errors.sms_from = translate("resources.storeMessages.validation.smsFrom");
  }

  if (!values.sms_text || values.sms_text.trim() === "") {
    errors.sms_text = translate("resources.storeMessages.validation.smsText");
  }

  if (!values.email_from || values.email_from.trim() === "") {
    errors.email_from = translate(
      "resources.storeMessages.validation.emailFrom"
    );
  }

  if (!values.email_text || values.email_text.trim() === "") {
    errors.email_text = translate(
      "resources.storeMessages.validation.emailText"
    );
  }

  if (!values.email_subject || values.email_subject.trim() === "") {
    errors.email_subject = translate(
      "resources.storeMessages.validation.emailSubject"
    );
  }

  if (!values.email_plaintext || values.email_plaintext.trim() === "") {
    errors.email_plaintext = translate(
      "resources.storeMessages.validation.plainText"
    );
  }

  if (
    !values.email_html ||
    values.email_html.trim() === "" ||
    values.email_html === "<p><br></p>"
  ) {
    errors.email_html = translate(
      "resources.storeMessages.validation.emailHtml"
    );
  }

  return errors;
};

export const validateStoreName = (value, allValues, props) =>
  (!value || value.trim() === "") &&
  props.translate("resources.virtualSlips.validation.requiredStoreName");



// WEBPACK FOOTER //
// ./src/containers/CRM/StoreMessages/validations.js